import React, { Fragment, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withRouter } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DefaultSettings from '../components/settings';
import { getEnvVariable } from '../../../modules/environmentalList';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        "& .MuiCollapse-wrapperInner": {
            marginBottom: '0.5rem',
        },
        marginTop: 3
    },
    heading: {
        fontSize: theme.typography.pxToRem(16),
        flexBasis: '63.33%',
        flexShrink: 0,
        color: 'rgb(13, 71, 161)',
        fontWeight: 400
    },

    error: {
        fontSize: theme.typography.pxToRem(16),
        flexBasis: '33.33%',
        flexShrink: 0,
        color: '#fafafa',
        fontWeight: 400
    },

    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
}));

function Accordions(props) {
    const { steps, view, sections, SectionContext, sectionKeysData, errorSections, hideSections } = props;
    const [expanded, setExpanded] = useState([0])
    const classes = useStyles();
    return (
        <div className={classes.root}>
            {sections.map((section, index) => {
                if (hideSections.includes(steps[index])) {
                    return null
                }
                return <Accordion key={index} className={steps[index] + ' applicaiton-border-radius my-2'}
                    defaultExpanded={section.length > 0 && sectionKeysData &&
                        sectionKeysData[section[0].props.SectionKey] === true}
                    elevation={0}
                    style={{
                        // border: '1px solid ',
                        borderRadius: '10px',
                        marginLeft: 3,
                        marginRight: 3,
                        boxShadow: expanded.includes(index) ? '0 0 5px rgb(209, 217, 220)' : 'none',
                        //  backgroundColor: expanded.includes(index) ? 'rgb(209, 217, 220)' : '#fff' // Change as needed
                    }}
                    expanded={expanded.includes(index) ? true : false}
                    onChange={(event, isExpanded) => {
                        if (isExpanded) {
                            setExpanded([...expanded, index]);
                        } else {
                            setExpanded(expanded.filter(item => item !== index));
                        }
                    }}
                >
                    <AccordionSummary
                        style={{
                            backgroundColor: errorSections[steps[index]] === true ? '#f44336' : '',
                            flexDirection: 'row-reverse',
                            maxHeight: '45px', minHeight: '45px',
                            borderRadius: '10px',
                            padding: '0px',
                        }}
                        expandIcon={<ExpandMoreIcon />}
                        IconButtonProps={{
                            disableRipple: true
                        }}

                    >
                        {/* <div className='mx-1' /> */}
                        <Typography className={errorSections[steps[index]] === true ? classes.error :
                            classes.heading} >{steps[index] === 'Header' ? `Record Information` : steps[index] === 'Applicant Information' ? `Company/Applicant Information` : steps[index]} &nbsp;
                            {SectionContext && steps[index] && SectionContext[steps[index]] &&
                                < Tooltip title={SectionContext[steps[index]] ? SectionContext[steps[index]].SectionDescription : null} placement="bottom-start" >
                                    <HelpOutlineIcon fontSize="small" style={{ width: '0.6em', paddingBottom: 5, color: getEnvVariable('ModuleKey') === 'AEPS' ? "#00355f" : '#007bff' }}
                                        onClick={() => DefaultSettings.showDrawer(SectionContext[steps[index]].SectionContextHelp)} />
                                </Tooltip>}
                        </Typography>
                    </AccordionSummary>
                    <div className="col-sm-12 ">
                        {section.map((eachsec, idx) => {
                            return <AccordionDetails key={idx} className={eachsec.props.className} >
                                <div className="col-sm-11 mx-3">{eachsec}</div>
                            </AccordionDetails>
                        })}
                    </div>
                </Accordion>
            })}
        </div>
    );
}

export default withRouter(Accordions)